import { computed, toValue, type MaybeRefOrGetter } from "vue";
import { TIntegracaoCampoModel } from "../@types/IntegracaoCampoModel";

function valoresSaoEquivalentesParaReset(
  primeiroValor: unknown,
  segundoValor: unknown
): boolean {
  if (Object.is(primeiroValor, segundoValor)) return true;

  if (!Array.isArray(primeiroValor) || !Array.isArray(segundoValor)) {
    return false;
  }

  if (primeiroValor.length !== segundoValor.length) return false;

  return primeiroValor.every((elemento, indice) =>
    Object.is(elemento, segundoValor[indice])
  );
}

export default function useDynamicForm(
  campos: MaybeRefOrGetter<TIntegracaoCampoModel[]>
) {
  const nomesCamposControleRegra = computed(() => {
    const listaCampos = toValue(campos);
    const nomesReferenciadores = listaCampos
      .map((campo) => campo.regraExibicao?.nomeCampo)
      .filter((nome): nome is string => Boolean(nome));

    return [...new Set(nomesReferenciadores)];
  });

  return {
    valoresEquivalentesParaReset: valoresSaoEquivalentesParaReset,
    nomesCamposControleRegra
  };
}
